var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.data),function(rec,index){return _c('div',{key:index,class:{'yellow': rec === _vm.highlight}},[_vm._v(_vm._s(rec))])}))}
var staticRenderFns = []

export { render, staticRenderFns }